"use strict";

exports.__esModule = true;
exports.ChevronLeftIcon = void 0;

var _icon = require("@chakra-ui/icon");

var ChevronLeftIcon = (0, _icon.createIcon)({
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
  displayName: "ChevronLeftIcon"
});
exports.ChevronLeftIcon = ChevronLeftIcon;
//# sourceMappingURL=ChevronLeft.js.map